import React from 'react';

import {SearchSummaryFields} from '../SearchSummaryFields';
import {SearchDetailsModal} from '../SearchDetailsModal';
import {SearchDetailsFields} from '../SearchDetailsFields';

import {useComponent} from './hooks';

import './SearchForm.less';

import '../SearchFields/SearchFields.less';
import '../SearchField/SearchField.less';
import '../SearchInputField/SearchInputField.less';
import '../SearchButtonField/SearchButtonField.less';
import '../SearchModal/SearchModal.less';

function SearchForm(props) {
    const {
        className,
        showSummary,
        onSubmit
    } = useComponent(props);

    return (
        <form className={className} onSubmit={onSubmit}>
            {showSummary ? (
                <>
                    <SearchSummaryFields/>
                    <SearchDetailsModal/>
                </>
            ) : (
                <SearchDetailsFields/>
            )}
        </form>
    );
}

SearchForm.whyDidYouRender = true;

export default SearchForm;
export {SearchForm};
